// pages/Careers.jsx
import React from "react";
import { motion } from "framer-motion";

const Careers = () => {
  return (
    <>
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 text-white py-5 text-center">
        <h1 className="text-4xl font-bold mb-4">Careers</h1>
        <p className="text-blue-200 max-w-2xl mx-auto">
          Join our team and help shape the future of technology with MetaVix Solutions.
        </p>
      </section>
      <motion.section
        className="py-16 bg-gray-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="container mx-auto px-4 max-w-3xl">
          <motion.h2
            className="text-3xl font-bold mb-6 text-blue-600 text-center"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
          </motion.h2>

          <motion.p
            className="mb-6 text-gray-700"
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            At MetaVix, innovation, collaboration, and transformation are core to everything we do. Positioned at the cutting edge of Cloud Solutions and Services, we redefine digital business operations. Explore exciting opportunities if you have a passion for technology and Oracle solutions.
          </motion.p>

          <motion.h3
            className="text-2xl font-semibold mb-2"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Life at MetaVix
          </motion.h3>
          <motion.p
            className="mb-4 text-gray-700"
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            Employee engagement, learning, and team events.
          </motion.p>

          <motion.h3
            className="text-2xl font-semibold mb-2"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            Join Our Journey
          </motion.h3>
          <motion.p
            className="mb-4 text-gray-700"
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 1 }}
          >
            Explore opportunities shaping the future of digital businesses.
          </motion.p>

          <motion.h3
            className="text-2xl font-semibold mb-2"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 1.2 }}
          >
            How to Apply
          </motion.h3>

          <motion.form
            className="space-y-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 1.4 }}
          >
            <input type="text" placeholder="Full Name" className="w-full p-3 border rounded-md" required />
            <input type="email" placeholder="Email" className="w-full p-3 border rounded-md" required />
            <input type="text" placeholder="Position Applying For" className="w-full p-3 border rounded-md" required />
            <textarea placeholder="Your Message" className="w-full p-3 border rounded-md" rows={4}></textarea>
            <motion.button
              type="submit"
              className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition transform hover:scale-105"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Submit
            </motion.button>
          </motion.form>
        </div>
      </motion.section>
    </>
  );
};

export default Careers;